import { render, staticRenderFns } from "./UserSocialAccounts.vue?vue&type=template&id=13d11053&"
import script from "./UserSocialAccounts.vue?vue&type=script&lang=js&"
export * from "./UserSocialAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports